import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { DeleteModal, Modal } from "../../Modal";
import {
  defineRole,
  defineRoleCenterSite,
} from "../../../utils/handleAccessRoles";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import { ROLE_COLLECTIONS } from "../../../constants/ROLES";
import handleFilters from "../../../utils/handleFilters";
import moment from "moment";
import exportPDF from "../../../utils/exportPDF";
import { CSVLink } from "react-csv";
import {
  deletePackaging,
  fetchPackagingData,
} from "../../../utils/queries/packagingQuery";
import Packages from "./Packages";
import { fetchEquipments } from "../../../utils/queries/equipmentQuery";
import donationQuery from "../../../utils/queries/bloodDonationQuery";
import toastMessage from "../../../utils/toastMessage";

// eslint-disable-next-line no-unused-vars
let copyData = [];

class PackagingList extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    filters: {
      startDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      endDate: moment().endOf("d").format("YYYY-MM-DD"),
    },
    code: "",
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.fetchData(true, {
      ...this.state.filters,
      status: this.props.status,
    });
  };

  fetchData = async (isLoading, search) => {
    let updatedFilters = {
      ...this.state.filters,
      ...search,
    };

    // console.log(search);

    this.setState({ filters: updatedFilters });

    if (updatedFilters.coolerBox || updatedFilters.donation) {
      delete updatedFilters.startDate;
      delete updatedFilters.endDate;
    }

    this.getData(isLoading, updatedFilters);
  };

  onChangeText(field, e) {
    console.log(field, e);
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e && e?.target ? e?.target?.value : e,
      error,
    });
  }

  returnFilters = async (search) => {
    const { page, limit } = this.state;
    const { centerId, centerSiteId, customFilters } = this.props;
    const { centerRole, centerSiteRole } = await defineRoleCenterSite();

    let params = {
      page,
      limit,
      code: this.props.code,
      id: this.props.donationId,
      center: centerId || centerRole,
      centerSite: centerSiteId || centerSiteRole,
      ...handleFilters(search),
      ...search,
      ...(customFilters || {}),
    };

    return params;
  };

  getData = async (isLoading, search = {}) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      let params = await this.returnFilters(search);

      const { data, count, totalRecords } = await fetchPackagingData(defaultLanguage, {
        "coolerBox.type": this.props.type,
        "coolerBox.types": this.props.coolerBoxTypes,
        ...params,
        grouping: true,
      });
      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true, this.state.filters);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].cooler_box,
        key: "coolerBox.name",
        styles: {
          textTransform: "uppercase",
        },
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showPackage", item.coolerBoxCode, item),
      },

      {
        title: language[this.props.defaultLanguage].cooler_box_code,
        key: "coolerBox.code",
        styles: {
          textTransform: "uppercase",
        },
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showPackage", item.coolerBoxCode, item),
      },
      this.props?.type === "SAMPLE" && {
        title: language[this.props.defaultLanguage].sample_Type,
        key: "sampleType",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].total_packages,
        key: "totalPackage",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].plate_number,
        key: "plateNumber.code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ].filter(Boolean);

    return headers;
  }

  returnTablePackagesHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donation.donationNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].cooler_box,
        key: "coolerBox.name",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].cooler_box_code,
        key: "coolerBox.code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "coolerBox.type",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].transportation_temperature,
        key: "transportationTemperature",
      },

      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].plate_number,
        key: "plateNumber.code",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].packaging_date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },

      {
        title: language[this.props.defaultLanguage].driver,
        key: "driver",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].driver_contact,
        key: "driverContact",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].transfer_date,
        key: "transferDate",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].received_by,
        key: "receivedBy.pin",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].received_date,
        key: "receivedDate",
        isMoment: true,
        formatTime: "lll",
      },
    ];

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deletePackaging(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData();
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    if (!search || search === "") {
      await this.fetchData(true, {
        "coolerBox.types": this.state.type?.value
          ? [this.state.type?.value]
          : this.props.coolerBoxTypes,
        coolerBox: undefined,
        donation: undefined,
        status: this.state.status?.value
          ? [this.state.status?.value]
          : this.props.status,
        page: 1,
        limit: 10,
      });

      this.setState({
        searching: false,
      });

      return;
    }

    const equipment = await fetchEquipments(this.props.defaultLanguage, {
      q: search,
    });

    if (equipment?.length > 0) {
      await this.fetchData(true, {
        status: this.state.status?.value
          ? [this.state.status?.value]
          : this.props.status,
        coolerBox: equipment[0]._id,
        page: 1,
        limit: 10,
      });
    } else {
      const donation = await donationQuery(this.props.defaultLanguage, {
        donationNumber: search,
      });

      if (donation?.length > 0) {
        await this.fetchData(true, {
          status: this.state.status?.value
            ? [this.state.status?.value]
            : this.props.status,
          donation: donation[0]._id,
          page: 1,
          limit: 10,
        });
      } else {
        toastMessage(
          "error",
          language[this.props.defaultLanguage].no_data_found
        );
      }
    }

    this.setState({
      searching: false,
    });
  };

  downloadExcel = async (search = {}) => {
    try {
      this.setState({
        isLoading: true,
      });

      const { defaultLanguage } = this.props;

      let params = await this.returnFilters(search);

      const { data } = await fetchPackagingData(defaultLanguage, params);

      const formateData = data.map((el) => {
        return {
          code: el.code,
          name: el.coolerBox.name,
          addedBy: el?.addedBy?.pin || "-",
          receivedBy: el?.receivedBy?.pin || "-",
          center: el.center.name,
          centerSite: el.centerSite.name,
          status: el.status,
          receivedDate: el.receivedDate
            ? moment(el.receivedDate).format("lll")
            : "-",
          createdAt: moment(el.createdAt).format("lll"),
        };
      });

      this.setState({
        isLoading: false,
        csvData: formateData,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async (search = {}) => {
    this.setState({
      isLoading: true,
    });

    const { defaultLanguage } = this.props;

    const headers = this.returnTablePackagesHeaders();

    let params = await this.returnFilters(search);

    const { data } = await fetchPackagingData(defaultLanguage, {
      ...params,
      grouping: false,
    });

    this.setState({
      isLoading: false,
    });

    exportPDF("Packagings", headers, data);
  };

  render() {
    const { add_package } = language[this.props.defaultLanguage];

    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={this.handleSearch.bind(this)}
          addSearchButton
          searching={this.state.searching}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          addButtonText={add_package}
          fetchData={(isLoading, search) => this.fetchData(isLoading, search)}
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: (item) => this.fetchData(true, this.state.filters),
            },
            {
              type: "export",
              title: language[this.props.defaultLanguage].export_,
              button_type: "dropdown",
              icon: "bx bxs-download",
              options: [
                {
                  name: "PDF",
                  onPress: () => this.downloadPDF(this.state.filters),
                },
                {
                  name: "CSV",
                  onPress: () => this.downloadExcel(this.state.filters),
                },
              ],
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_COLLECTIONS,
                operation: "read",
              }),
              name: language[this.props.defaultLanguage].view,
              onPress: (item) =>
                this.handleShowModal("showPackage", item.coolerBoxCode, item),
            },
            // {
            //   canAccess: defineRole({
            //     roles: this.state.user.accessRole,
            //     menu: ROLE_COLLECTIONS,
            //     operation: "update",
            //   }),
            //   name: language[this.props.defaultLanguage].update,
            //   onPress: (item) =>
            //     this.handleShowModal("showPackage", item.coolerBoxCode, item),
            // },
            // {
            //   canAccess: defineRole({
            //     roles: this.state.user.accessRole,
            //     menu: ROLE_COLLECTIONS,
            //     operation: "delete",
            //   }),
            //   name: language[this.props.defaultLanguage].delete_,
            //   onPress: (item) =>
            //     this.handleShowModal("showPackage", item.coolerBoxCode, item),
            // },
          ]}
          moreFilters={[
            {
              inputType: "selection",
              placeholder: language[this.props.defaultLanguage].status,
              value: this.state.status,
              onChange: (e) => this.onChangeText("status", e),
              options: [
                // this.props.status?.includes("pending") &&
                {
                  label: language[this.props.defaultLanguage].pending,
                  value: "pending",
                },
                this.props.status?.includes("transferred") && {
                  label: language[this.props.defaultLanguage].transferred,
                  value: "transferred",
                },
                this.props.status?.includes("received") && {
                  label: language[this.props.defaultLanguage].received,
                  value: "received",
                },
              ].filter(Boolean),
            },
            {
              inputType: "selection",
              placeholder: language[this.props.defaultLanguage].type,
              value: this.state.status,
              onChange: (e) => this.onChangeText("type", e),
              options: [
                {
                  label: language[this.props.defaultLanguage].big,
                  value: "BIG",
                },
                {
                  label: language[this.props.defaultLanguage].medium,
                  value: "MEDIUM",
                },
                {
                  label: language[this.props.defaultLanguage].sample_coolderbox,
                  value: "SAMPLE",
                },
              ].filter(Boolean),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showPackage")}
          show={this.state.showPackage}
          title={this.state.modalTitle}
          size="lg"
        >
          <div className="card-body">
            <Packages
              status={this.state.selectedData.status}
              coolerBoxId={this.state.selectedData.coolerBoxId}
              sample={this.state.selectedData.sampleType}
              handleCloseModal={this.handleCloseModal.bind(this, "showPackage")}
            />
          </div>
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal",
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>

        <CSVLink
          ref={this.csvDownload}
          filename={"Packaging"}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(PackagingList);
